// Errors for transition messages

import type { TransitionMessages } from '../../types';

export const ERRORS: Record<string, TransitionMessages> = {
  generic: {
    top: {
      'en-US': 'Oops, something went wrong',
      'en-GB': "Oh dear, something's gone wrong",
      'en-AU': "Whoops! That didn't work...",
      'en-IN': 'Oops, something went wrong',
      'es-ES': 'Vaya, algo ha salido mal',
      'es-US': 'Ups, algo salió mal',
    },
  },
  unableToLoadGame: {
    top: {
      'en-US': 'Unable to load game...',
      'en-GB': 'Unable to load the game...',
      'en-AU': "Couldn't load the game...",
      'en-IN': 'Unable to load the game...',
      'es-ES': 'No se pudo cargar el juego...',
      'es-US': 'No se pudo cargar el juego...',
    },
  },
  failedToConnect: {
    top: {
      'en-US': 'Failed to connect to room',
      'en-GB': 'Failed to connect to the room',
      'en-AU': 'Failed to connect to your room',
      'en-IN': 'Failed to connect to the room',
      'es-ES': 'Error al conectar a la sala',
      'es-US': 'Error al conectar a la sala',
    },
  },
};
